import { render, staticRenderFns } from "./ScoreField.vue?vue&type=template&id=c0f34786&scoped=true"
import script from "./ScoreField.vue?vue&type=script&lang=js"
export * from "./ScoreField.vue?vue&type=script&lang=js"
import style0 from "./ScoreField.vue?vue&type=style&index=0&id=c0f34786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f34786",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
